import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { LoadingProvider } from './contexts/LoadingContext'
import { ensureConfigLoaded } from './config/environment'
import './index.css'
import 'react-toastify/dist/ReactToastify.css'

// Initialize config before rendering app
ensureConfigLoaded().then(() => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
      <LoadingProvider>
        <AuthProvider>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </AuthProvider>
      </LoadingProvider>
    </BrowserRouter>
  )
}).catch((error) => {
  console.error('Failed to initialize config:', error)
  // Still render even if config fails to load (fallbacks will be used)
  ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
      <LoadingProvider>
        <AuthProvider>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </AuthProvider>
      </LoadingProvider>
    </BrowserRouter>
  )
})
